export const TypeFilterTabs = ({ activeType, onTypeChange, className = "" }) => {
  const types = [
    { key: null, label: "All Types" },
    { key: "discussion", label: "Discussions", color: "blue" },
    { key: "mock", label: "Validation", color: "amber" },
    { key: "donation", label: "Donations", color: "emerald" },
  ];
  return (
    <div className={`flex gap-1.5 overflow-x-auto scrollbar-hide ${className}`}>
      {types.map(t => (
        <button key={t.key || "all"} onClick={() => onTypeChange(t.key)}
          data-testid={`type-filter-${t.key || 'all'}`}
          className={`px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all duration-200 ${
            activeType === t.key
              ? t.color === "blue" ? 'bg-blue-100 text-blue-700 ring-1 ring-blue-300'
              : t.color === "amber" ? 'bg-amber-100 text-amber-700 ring-1 ring-amber-300'
              : t.color === "emerald" ? 'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-300'
              : 'bg-jeekota-primary text-white'
              : 'bg-gray-50 text-gray-500 hover:bg-gray-100'
          }`}>
          {t.label}
        </button>
      ))}
    </div>
  );
};
